(function () {

  function updateSize(selectEl) {
    const descSize = document.getElementById('desc_size');
    if (!descSize || !selectEl) return;

    const selectedText =
      selectEl.options[selectEl.selectedIndex].text.trim();
      descSize.textContent = selectedText;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const select = document.querySelector('.product-form__single-selector');
    updateSize(select);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('product-form__single-selector')) {
      updateSize(e.target);
    }
  });
})();

document.addEventListener('click', async function (e) {
  //debugger;
  const btn = e.target.closest('.line-item__quantity-remove1');
  if (!btn) return;

  const data = {
    hash: btn.dataset.hash,
    key: btn.dataset.key
  };
  console.log(btn);
  // Alag variable - data ke bahar
  const imprintingId = btn.dataset.imprintinid; 

  console.log(imprintingId);
  
  //  await fetch('/cart/update.js', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         updates: { [imprintingId]: 0 }
  //       })
  //     });

  try {
    await cartUpdate(data);
    await updateMinFee();
    window.location.reload();
  } catch (err) {
    console.error('Error updating cart:', err);
  }
});

const cartUpdate = ({ hash, key }) => {
  console.log('testing');
    const updates = {};
    updates[key] = 0;
    const items = document.querySelectorAll(`[data-item-hash='${hash}']`);
    items.forEach((item) => {
      const itemKey = item.dataset.itemKey;
      if (itemKey) {
        updates[itemKey] = 0;
      }
    });

    console.log("Updated formData1:", JSON.stringify(updates, null, 2));

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    }).then((response) => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    });
  };


const updateMinFee = async () => {

  const minFeePrice = window.cartConfig.minFeePrice;
  const minFeeId = window.cartConfig.minFeeId;

  const response = await fetch('/cart.js');
  const cart = await response.json();
  const items = cart.items;

  let imprintingItems = [];
  let imprintingproductsItems = [];
  let hasChanged = false;

  const totalImpFee = items.reduce((acc, item) => {

    if (item?.properties?._imprinting === "Imprinting") {

      const price = Number(item.properties._imprintinPrice);
      const qty = Number(item.properties._imprintinQty);
      const id = Number(item.properties._imprintinId || 0);
      const product_id = Number(item.properties._imprintinproduct_id || 0);

console.log('fdfdf'+ product_id);
      acc += price * qty;

      imprintingItems.push({
        id: id,
        quantity: qty
      });

      imprintingproductsItems.push({
        product_id: product_id
      });
    }

    return acc;

  }, 0);

  const lineItemMinFeeAdded = items.find(
    item => String(item.id) === String(minFeeId)
  );

  const uniqueIds = [
    ...new Set(imprintingproductsItems.map(item => item.product_id))
  ];

  const matchingCartItems = items.filter(item =>
    uniqueIds.includes(Number(item.product_id))
  );

  const buildZeroUpdates = (ids) => {
    const obj = {};
    ids.forEach(id => {
      obj[id] = 0;
    });
    return obj;
  };

  const matchingCartItemIds = matchingCartItems.map(
    item => Number(item.id)
  );

  // =====================================================
  // 🔴 CASE 1 → Need Min Fee
  // =====================================================
  if (totalImpFee > 0 && totalImpFee < minFeePrice) {

    if (!lineItemMinFeeAdded) {

      hasChanged = true;

      if (matchingCartItemIds.length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: buildZeroUpdates(matchingCartItemIds)
          })
        });
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: minFeeId, quantity: 1 }]
        })
      });
    }

  }

  // =====================================================
  // 🟢 CASE 2 → Remove Min Fee
  // =====================================================
  else {

    console.log('163');

    if (lineItemMinFeeAdded) {

      hasChanged = true;

      // Remove min fee
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [minFeeId]: 0 }
        })
      });

      console.log(imprintingItems);
      // 🔁 SAFE RECHECK BEFORE ADDING IMPRINTING
      if (imprintingItems.length) {
        console.log('178');

        const latestRes = await fetch('/cart.js');
        const latestCart = await latestRes.json();
        const latestItems = latestCart.items;

        const itemsToAdd = [];
        const updates = {};

        imprintingItems.forEach(imprintItem => {

          const existingItem = latestItems.find(
            item => Number(item.id) === Number(imprintItem.id)
          );

          if (!existingItem) {
            // Not in cart → add
            itemsToAdd.push(imprintItem);
          }
          else if (
            Number(existingItem.quantity) !== Number(imprintItem.quantity)
          ) {
            // Qty mismatch → update
            updates[imprintItem.id] = imprintItem.quantity;
          }

        });

        if (Object.keys(updates).length) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }

        if (itemsToAdd.length) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: itemsToAdd
            })
          });
        }
      }
    }
  }

  // =====================================================
  // 🔄 Reload Only If Changed
  // =====================================================
  if (hasChanged) {
    window.location.reload();
  }

};



updateMinFee();
function imprintTotal() {
  return {
    total: 0,
    async loadCart() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      let sum = 0;
      cart.items.forEach(item => {
        if (item.properties?._imprinting === "Imprinting") {
          const price = Number(item.properties._imprintinPrice || 0);
          const qty   = Number(item.properties._imprintinQty || 0);
          sum += price * qty;
        }
      });
      this.total = sum / 100;
    }
  }
}